import Component from './CommissionCreateButton';
import Container from './CommissionCreateButton.container';

export default Container(Component);
